import { httpProxy } from '../api';

export const adminAPI = {
  // Users
  getAllUsers: async () => {
    const response = await httpProxy.get('/admin/users');
    return response.data;
  },

  // Brands
  getAllBrands: async () => {
    const response = await httpProxy.get('/admin/brands');
    return response.data;
  },

  getBrandPrompts: async (brandId: number) => {
    const response = await httpProxy.get(`/admin/brand/${brandId}/prompts`);
    return response.data;
  },

  getBrandCompetitors: async (brandId: number, params?: any) => {
    const response = await httpProxy.get(`/admin/brand/${brandId}/competitors`, { params });
    return response.data;
  },

  getBrandSources: async (brandId: number, params?: any) => {
    const response = await httpProxy.get(`/admin/brand/${brandId}/sources`, { params });
    return response.data;
  },

  triggerDomainScan: async (brandId: number) => {
    const response = await httpProxy.post(`/admin/brand/${brandId}/trigger-domain-scan`);
    return response.data;
  },

  triggerPrompts: async (brandId: number) => {
    const response = await httpProxy.post(`/admin/brand/${brandId}/trigger-prompts`);
    return response.data;
  },

  triggerTechnicalAnalysis: async (brandId: number) => {
    const response = await httpProxy.post(`/admin/brand/${brandId}/technical-analysis`);
    return response.data;
  },

  triggerBlogSuggestions: async (brandId: number) => {
    const response = await httpProxy.post(`/admin/brand/${brandId}/blogs-suggestions`);
    return response.data;
  },

  // Jobs
  getAllJobs: async () => {
    const response = await httpProxy.get('/admin/jobs');
    return response.data;
  }
};

export default adminAPI;
